import { render, staticRenderFns } from "./ImportAppointments.vue?vue&type=template&id=1f209b0b&"
import script from "./ImportAppointments.vue?vue&type=script&lang=js&"
export * from "./ImportAppointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports